module.exports = __webpack_public_path__ + "img/avatar.e6a0836a.svg";